import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { SubHeadline } from '~components/Typography';

export const PromocodeWrapper = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	padding: 0.6rem 2rem;
	border-radius: var(--radius-s);
	gap: var(--gap-x2);

	&.opened {
		padding: 1.2rem 2rem 2rem;
		border: 1px solid var(--color-white-xs);
	}
`;

export const PromocodeButton = styled(SubHeadline)`
	user-select: none;
	& p span {
		color: var(--color-white-solid);
		cursor: pointer;
		text-decoration-line: underline;
		text-decoration-skip-ink: auto;
		text-decoration-style: dotted !important;
		text-decoration-thickness: 12%;
		text-underline-offset: auto;
		text-underline-position: from-font;
	}
`;

export const OpenedContent = styled.div`
	display: flex;
	width: 100%;
	gap: var(--gap-x2);
`;

export const input = css`
	border-radius: var(--radius-l);
`;
